<template>
    
    <div id="log-overview" class="w-100">
        <Overview 
            moduleName="Audit Trail"
            moduleNamePlural="Audit Trail"
            sort="created_at"
            :sortOrder="-1"
            newButtonName=""
            :selectFields=selectFields
            :itemService=itemService
            :itemFormRef=itemFormRef
            :showDropdown="false"
            :rows=20000 
            modalSize="modal-xl"
        >
            <template #columns>
                <Column field="created_at" :header="$t('overview.date')" :sortable="true" style="width: 200px">
                    <template #body="slotProps">
                        {{formatDate(slotProps.data.created_at, 'dateTime')}}
                    </template>
                </Column>
                <Column field="user.email" :header="$t('navigation.users')" :sortable="true" style="width: 300px">
                    <template #body="slotProps">
                        {{slotProps.data.user_name}}
                        
                    </template>
                </Column>
                <Column field="formatted_log" :header="$t('overview.actions')" :sortable="true"></Column>
            </template>
            <template #form>
                <LogDetail ref="ItemForm" :itemData="item" />
            </template>
        </Overview>
        <a id="log-opener" class="d-none" data-bs-toggle="modal" data-bs-target="#formModal"> </a>
        <div id="inv_button"></div>
    </div>
</template>

<script>
import LogDetail from '@/components/log/LogDetail.vue';
import Overview from '@/components/Overview.vue';
import Column from 'primevue/column';
import logService from '@/services/LogService'
import store from '@/store/user'

export default {
    components: {
        Overview,
        Column,
        LogDetail
    },
    props: {
        id: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            item: {},
            itemService: logService,
            itemFormRef: null,
            navName: 'navigation.logs',
            companyTypes: [],
            selectFields: []
        }
    },
    mounted() {
        console.log('Employee id:', this.id);
        this.itemFormRef = this.$refs.ItemForm;
    }
}
</script>